module.exports = __webpack_public_path__ + "static/media/lappy.6ab009e0.png";